import { render, staticRenderFns } from "./Televy.vue?vue&type=template&id=2171775b&"
import script from "./Televy.vue?vue&type=script&lang=js&"
export * from "./Televy.vue?vue&type=script&lang=js&"
import style0 from "./Televy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports